var _defs, _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpackNew226({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}.b{fill:#fff;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 3,
    y: 3,
    width: 10,
    height: 10
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M7.43,8H5.24v2H7.68v.61H4.52V5h3v.61H5.24V7.39H7.43Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M8.53,9.75a2.59,2.59,0,0,0,1.31.36c.74,0,1.17-.39,1.17-1S10.71,8.32,10,8c-.92-.32-1.49-.8-1.49-1.6A1.63,1.63,0,0,1,10.29,4.9a2.57,2.57,0,0,1,1.24.28l-.2.59a2.25,2.25,0,0,0-1.07-.26c-.77,0-1.06.46-1.06.84,0,.53.34.79,1.12,1.09.95.37,1.44.83,1.44,1.65s-.64,1.63-2,1.63a2.9,2.9,0,0,1-1.44-.36Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpackNew226);
export default __webpack_public_path__ + "static/media/Symbolpack_New_226.8d9aa8b022bbc1ce4f82e97847b18aa7.svg";
export { ForwardRef as ReactComponent };